import React from 'react';
import { MAIN_MENU_HEIGHT, BREAKPOINTS } from '../../ui/settings';
import { dynamicSrcSet } from '../../ui/helpers';
import useWindowSize from '../../hooks/useWindowSize';

import OImage from '../OImage';
import { WrapperHeader } from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import Chevron from '-!svg-react-loader!../../ui/svgs/icon-chevron.svg';
import { BillboardContainer } from './styles';

interface IProps {
  title: string;
  claim: string;
  desktopImage: any;
  mobileImage?: any;
  imageAlt: string;
}

const HomeBillboard = ({ title, claim, desktopImage, mobileImage, imageAlt }: IProps) => {
  /**
   * Old gradient
   * const gradients = themes.gradients.generic_gradient;
   */
  const gradients = themes.gradients.neutral_black;
  const basic = themes.basic.neutral_black;
  const vpSize = useWindowSize();

  const image = vpSize.width >= BREAKPOINTS.medium ? desktopImage : mobileImage;

  return (
    <BillboardContainer>
      <div></div>
      <div className='topContainer'>
        <div className='textWrapper'>
          <span className='title'>{title}</span>
          <span className='claim'>{claim}</span>
        </div>
        <img src={image?.original?.href} />
      </div>
      <div className='containerCta vertMove'>
        <button className='buttonCta' onClick={() =>
          window.scrollTo({
            top:
              Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) >
                BREAKPOINTS.medium
                ? Math.max(
                  document.documentElement.clientHeight || 0,
                  window.innerHeight || 0
                ) - MAIN_MENU_HEIGHT
                : Math.max(
                  document.documentElement.clientHeight || 0,
                  window.innerHeight || 0
                ) -
                MAIN_MENU_HEIGHT -
                32,
            behavior: 'smooth'
          })
        }>
          <Chevron className="svg" />
        </button>
      </div>
    </BillboardContainer>
  );
};

export default HomeBillboard;
